/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-30 11:15:20
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Skeleton/Skeleton.tsx
 */
import React from 'react';

import { Skeleton } from 'antd';
const S = (props) => {
  const { ...rest } = props;
  return <Skeleton {...rest} />;
};
S.Button = Skeleton.Button;
S.Avatar = Skeleton.Avatar;
S.Input = Skeleton.Input;
S.Image = Skeleton.Image;
export default S;
